import { SET_ACTIVE_PAGE } from '../actionsTypes';

const setActivePage = (page) => ({ type: SET_ACTIVE_PAGE, payload: page });

export default setActivePage;
